import * as React from 'react';

import SkillMapMain from '../../components/SkillMap';
import Navbar from '../../containers/NavbarAdmin';
import i18n from '../../resources/i18n';
/**
 * マップ表示画面
 * @param props
 */
const SkillMapAdmin: React.FC<any> = props => {
	return (
		<>
			<Navbar title={i18n.t('SkillMapAdmin_0001')} />
			<SkillMapMain
				cmId={props.match.params.cmid}
				AdminView={true}
				targetUserId={props.match.params.user_id}
			/>
		</>
	);
};

export default SkillMapAdmin;



// WEBPACK FOOTER //
// ./src/pages/personal/SkillMapAdmin.tsx